import { render, staticRenderFns } from "./videoDialog.vue?vue&type=template&id=a1e1fff8&scoped=true&"
import script from "./videoDialog.vue?vue&type=script&lang=js&"
export * from "./videoDialog.vue?vue&type=script&lang=js&"
import style0 from "./videoDialog.vue?vue&type=style&index=0&id=a1e1fff8&prod&lang=css&"
import style1 from "./videoDialog.vue?vue&type=style&index=1&id=a1e1fff8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e1fff8",
  null
  
)

export default component.exports